import React from 'react';
import './CardButton.css';

/**
 * A button that appears on a profile/community card in the top-right corner.
 * Enables some action on that card.
 */
const CardButton = props => {
	return <button className="CardButton" {...props} />;
};

export default CardButton;



// WEBPACK FOOTER //
// ./src/widgets/CardButton.js